import angular from 'angular';

// Use Vite's import.meta.glob instead of bulk-require
const modules = import.meta.glob(['./**/*.js', '!./index.js', '!./**/*.spec.js'], { eager: true });

const servicesModule = angular.module('app.services', []);

function declare(mod) {
  if (!mod) return;
  
  const item = mod.default || mod;
  
  if (item.fn && typeof item.fn === 'function') {
    servicesModule.service(item.name, item.fn);
  }
}

Object.values(modules).forEach(declare);

export default servicesModule;
